import { track } from "@amplitude/analytics-react-native";
import { useCallback } from "react";
import { amp } from "src/api/amplitude";
import { BasicModularNavBarTemplate } from "src/components/ModularNavBar";
import { useGatheringContext } from "src/contexts/GatheringContext";
import useDevice from "src/hooks/useDevice";
import IconGear from "src/icons/IconGear";
import usePresentAdminPrivacy from "../../../hooks/usePresentAdminPrivacy";
import GatheringHomeAudioPlayerDisplay from "./GatheringHomeAudioPlayerDisplay";

const EditModeGatheringHomeNavBarContent = () => {
	const { store } = useGatheringContext();
	const handleDone = useCallback(async () => {
		const { setEditMode, editGatheringNameCallback } = store.getState();
		await editGatheringNameCallback?.("Save").catch(() => {});
		track(amp.gathering.editDoneButtonPressed);
		setEditMode("None");
	}, [store]);
	const { device } = useDevice();
	const { handlePresentAdminPrivacy } = usePresentAdminPrivacy({
		amplitudeEvent: amp.gathering.editPrivacyButtonPressed,
	});

	return (
		<BasicModularNavBarTemplate
			includeLogo={device === "desktop"}
			items={[
				[
					GatheringHomeAudioPlayerDisplay,
					{
						Icon: IconGear,
						onPress: handlePresentAdminPrivacy,
						testID: "GatheringNavBar-EditPrivacy",
					},
					{
						text: "Done",
						onPress: handleDone,
						testID: "GatheringNavBar-EditDone",
						important: true,
					},
				],
			]}
		/>
	);
};
export default EditModeGatheringHomeNavBarContent;
